<template>
<div class="container">
    <div class="row">
        <Button v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice" class="mb-3" @click="backStep" size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <RegisterHeader />
        <BoxRegister>
            <div class="col-8 mt-4">
                <h4 class="c-ndarkfour bold">
                    Usuários da empresa
                </h4>
            </div>
            <div class="col-4 mt-4 mb-5 d-flex justify-content-end">
                <Button type="outline" size="small" @click="newUser()" :color="getPrimaryColor">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.99983 1V9M1 5H8.99967" :stroke="getPrimaryColorHex.four" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Novo usuário
                </Button>
            </div>
            <div class="col-12 mb-4 box-users">
                <User v-if="this.$store.state.user.companyUsers.length" :tableData="$store.state.user.companyUsers" @deleteUserModal="dialogVisibleUserDelete = true; userToDelete.id = $event" />
                <EmptyUser v-else-if="!this.$store.state.user.companyUsers.length" />
            </div>
        </BoxRegister>
    </div>
    <UserDelete :dialogVisible="dialogVisibleUserDelete" @closeModal="dialogVisibleUserDelete = $event" @deleteUser="userDeleteRequest" />
    <ConfirmRegisterChange :dialogVisible="dialogVisible" @closeModal="dialogVisible = false"/>
</div>
</template>

<script>
//import CompanyTypeStatus from '@/components/status/CompanyTypeStatus'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import User from '@/components/tables/User'
import BoxRegister from '@/components/box/BoxRegister'
import getCompanyUsers from '@/api/getCompanyUsers'
import RegisterHeader from '@/components/register/RegisterHeader'
import ConfirmRegisterChange from '@/components/modals/ConfirmRegisterChange'
import deleteUser from '@/api/deleteUser'
import UserDelete from '@/components/modals/UserDelete'
import EmptyUser from '@/components/emptyOrNotFound/EmptyUser'

export default {
    components: {
        //CompanyTypeStatus,
        ArrowDropdown,
        User,
        BoxRegister,
        RegisterHeader,
        ConfirmRegisterChange,
        UserDelete,
        EmptyUser
    },
    data() {
        return {
            activeTab: '',
            dialogVisible: false,
            userToDelete: {
                id: null
            },
            dialogVisibleUserDelete: false,
        }
    },
    computed: {
        partnersList() {
            return this.$store.state.register.partners.filter(partners => partners.associateType != 'Procurador' && partners.name)
        },
        procuratorList() {
            return this.$store.state.register.partners.filter(partners => partners.associateType == 'Procurador' && partners.name)
        },
        allRegistersStatusIsComplete() {
            return this.$store.state.register.partners.every(partners => partners.registerComplete == 1)
        }
    },
    methods: {
        async userDeleteRequest() {
            if (this.userToDelete.id != null) {
                const result = await deleteUser({ userId: this.userToDelete.id, cnpjId: this.$route.params.idCNPJ })
                if (result.data.ok) {
                    this.$notify({
                        title: 'Usuário excluido com sucesso!',
                        message: '',
                        type: 'success',
                        duration: 3000,
                        offset: 100,
                        showClose: false
                    });
                    await getCompanyUsers(this.$route.params.idCNPJ)
                } else {
                    this.$notify({
                        title: 'Opa! Encontramos algum erro.',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            }
            this.userToDelete.id = null
            this.dialogVisibleUserDelete = false
        },
        backStep() {
            if (this.$store.state.user.userAdm || this.USER_TYPE_MIXIN.isBackOffice) {
                const regex = /provider|buyer|sponsor/g
                this.$router.push(`/company/${this.$route.path.match(regex)[0]|| 'provider'}`)
            } else {
                this.$router.push(`/company`)
            }
        },
        newUser() {
            this.$router.push(`/user/company/${this.$route.params.idCNPJ}/new`)
        },
    },
    async created() {
        await getCompanyUsers(this.$route.params.idCNPJ)
        this.$store.commit('register/setFormIsChanged', false)
    }
}
</script>

<style lang="scss" scoped>
.box-users {
    height: 375px;
    overflow: scroll;
}
</style>
